/**
 * Culture design intelligence — cultural visual and typographic nuance.
 * Keyed by culture slug. Additive, pure data.
 */

export const CULTURE_KNOWLEDGE = Object.freeze({
  western: { asOf: '2026', confidence: 0.6, typographyDirection: ['clean-sans-hierarchy'] },
  arabic: { asOf: '2026', confidence: 0.62, typographyDirection: ['arabic-aware-elegant-type'], compositionDirection: ['rtl-aware'], colorPsychology: ['gold-and-jewel-tones-read-premium'] },
  indian: { asOf: '2026', confidence: 0.6, colorPsychology: ['vibrant-festive-color'], visualTrends: ['ornamental-motifs'] },
  'east-asian': { asOf: '2026', confidence: 0.6, colorPsychology: ['red-and-gold-are-auspicious'], compositionDirection: ['balanced-dense-layouts'] },
});
